import { getAuth } from 'firebase/auth';

class GuestPortalService {
  constructor() {
    // Use relative URLs in development (proxy will handle it) or explicit API URL
    this.API_BASE_URL = process.env.REACT_APP_API_URL || '';
    this._auth = null;
  }

  get auth() {
    if (!this._auth) {
      try {
        this._auth = getAuth();
      } catch (error) {
        return null;
      }
    }
    return this._auth;
  }

  async waitForFirebase(maxAttempts = 10) {
    for (let i = 0; i < maxAttempts; i++) {
      try {
        const auth = getAuth();
        if (auth) {
          this._auth = auth;
          return auth;
        }
      } catch (error) {
        // retry
      }
      await new Promise(resolve => setTimeout(resolve, 300));
    }
    throw new Error('Firebase auth failed to initialize');
  }

  async authedFetch(endpoint, options = {}) {
    const auth = await this.waitForFirebase();
    if (!auth.currentUser) throw new Error('User not authenticated');
    const token = await auth.currentUser.getIdToken();
    const res = await fetch(`${this.API_BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...(options.headers || {})
      }
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
    return data;
  }

  // Admin endpoints
  async createPortal(episodeOrId, { guestName = '', guestTitle = '', topics = [], expiresInDays = 14 } = {}) {
    const episodeId = typeof episodeOrId === 'object' ? episodeOrId.id : episodeOrId;
    return this.authedFetch('/api/guest-portal/create', {
      method: 'POST',
      body: JSON.stringify({ episodeId, guestName, guestTitle, topics, expiresInDays })
    });
  }

  async getPortalByEpisode(episodeId) {
    return this.authedFetch(`/api/guest-portal/admin/by-episode/${encodeURIComponent(episodeId)}`);
  }

  async deactivatePortal(token) {
    return this.authedFetch(`/api/guest-portal/${encodeURIComponent(token)}/deactivate`, { method: 'POST' });
  }

  async activatePortal(token) {
    return this.authedFetch(`/api/guest-portal/${encodeURIComponent(token)}/activate`, { method: 'POST' });
  }

  async regeneratePortal(token) {
    return this.authedFetch(`/api/guest-portal/${encodeURIComponent(token)}/regenerate`, { method: 'POST' });
  }

  async sendInvitationEmail(token, emailData) {
    return this.authedFetch(`/api/guest-portal/${encodeURIComponent(token)}/send-invitation`, {
      method: 'POST',
      body: JSON.stringify(emailData)
    });
  }
}

const guestPortalService = new GuestPortalService();
export default guestPortalService;


